import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-7c5c0994"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "play-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptimizedImage = _resolveComponent("OptimizedImage")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["media-container", { open: _ctx.open }]),
    style: _normalizeStyle({ height: _ctx.containerHeightPx, maxHeight: _ctx.containerHeightPx })
  }, [
    _createVNode(_component_OptimizedImage, {
      class: "cover-image",
      image: _ctx.image,
      width: 1600
    }, null, 8, ["image"]),
    (_ctx.videoUrl && !_ctx.playingVideo)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "play-button",
          "aria-label": "Start video",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playVideo && _ctx.playVideo(...args)))
        }, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.videoUrl && _ctx.playingVideo)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          src: _ctx.videoUrl,
          frameborder: "0",
          allow: "autoplay; fullscreen",
          ref: "video",
          "aria-label": "Video",
          allowfullscreen: ""
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 6))
}